<template>
  <div>
    <el-table
      :data="claimsPublic.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column
        label="Label"
        prop="label"
        sortable
        width="150%"
      ></el-table-column>
      <el-table-column
        label="Channel name"
        prop="channelId"
        sortable
        width="250%"
      >
        <template slot-scope="props">
          <a
            :href="`https://youtube.com/channel/${props.row.channelId}`"
            target="_blank"
          >
            {{ props.row.channelName }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Video" prop="title" sortable>
        <template slot-scope="props">
          <a
            :href="`https://youtube.com/watch?v=${props.row.videoId}`"
            target="_blank"
          >
            {{ props.row.title }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Asset" prop="asset" sortable></el-table-column>
      <el-table-column label="Video published" prop="published_at" sortable>
        <template slot-scope="props">
          {{ props.row.published_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Type" prop="type" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.type == 'Private'" type="danger">
            {{ props.row.type }}
          </el-tag>
          <el-tag v-else type="success">
            {{ props.row.type }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Status" prop="status" sortable></el-table-column>
      <el-table-column label="License" prop="license" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.license == 'Yes'" type="success">
            {{ props.row.license }}
          </el-tag>
          <el-tag v-else-if="props.row.license == 'No'" type="danger">
            {{ props.row.license }}
          </el-tag>
          <el-tag v-else type="warning">
            {{ props.row.license }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="Description"
        prop="description"
        sortable
      ></el-table-column> -->
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Release claim" placement="right">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-check"
              @click="release(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Confirm claim" placement="right">
            <el-button
              v-if="
                props.row.license !== 'Yes' && props.row.status == 'Potential'
              "
              type="danger"
              circle
              size="small"
              icon="el-icon-check"
              class="mt10"
              @click="confirm(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="float-right"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="claimsPublic.current_page"
        :page-sizes="[5, 10, 25, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="claimsPublic.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeClaims', [
      'claimsPublic',
      'loading',
      'order_column',
      'order_type',
      'page',
      'page_size',
    ])
  },

  methods: {
    ...mapMutations('youtubeClaims', [
      'setPage',
      'setPageSize',
      'setOrdering'
    ]),
    ...mapActions('youtubeClaims', [
      'readClaims',
      'readLabels',
      'releaseClaim',
      'confirmClaim'
    ]),
    release(row) {
      this.$confirm('You will release this claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.releaseClaim(row.claimId)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Claim cancelled'
          })
        })
    },
    confirm(row) {
      this.$confirm('You will confirm this claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.confirmClaim(row.claimId)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Claim cancelled'
          })
        })
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readClaims('Public')
    },
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readClaims('Public')
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readClaims('Public')
    },
  },

  created() {
    this.readClaims('Public')
    this.readClaims('Private')
    this.readLabels()
  }
}
</script>
]
